'use strict';

exports.__esModule = true;

var _styledBase = require('@emotion/styled-base');

var _styledBase2 = _interopRequireDefault(_styledBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TagList = ( /*#__PURE__*/0, _styledBase2.default)('div', {
	target: 'e1x48c4h0',
	label: 'TagList'
})('display:flex;flex-wrap:wrap;align-items:center;margin:0 -5px;max-wdth:100%;span{display:inline-block;margin:2px 5px;cursor:pointer;border-radius:0.25rem;padding:2px 4px;&.active{background-color:', function (_ref) {
	var theme = _ref.theme;
	return theme.colors.primaryColor;
}, ';color:', function (_ref2) {
	var theme = _ref2.theme;
	return theme.colors.primaryTextColor;
}, ';}}' + (process.env.NODE_ENV === 'production' ? '' : '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHlsZXMvVGFnTGlzdC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFNkIiLCJmaWxlIjoiLi4vLi4vc3JjL3N0eWxlcy9UYWdMaXN0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5jb25zdCBUYWdMaXN0ID0gc3R5bGVkKCdkaXYnKWBcblx0ZGlzcGxheTogZmxleDtcbiAgICBmbGV4LXdyYXA6IHdyYXA7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcblx0bWFyZ2luOiAwIC01cHg7XG5cdG1heC13ZHRoOiAxMDAlO1xuXG4gICAgc3BhbiB7XG5cdFx0ZGlzcGxheTogaW5saW5lLWJsb2NrO1xuXHRcdG1hcmdpbjogMnB4IDVweDtcblx0XHRjdXJzb3I6IHBvaW50ZXI7XG5cdFx0Ym9yZGVyLXJhZGl1czogMC4yNXJlbTtcblx0XHRwYWRkaW5nOiAycHggNHB4O1xuXG5cdFx0Ji5hY3RpdmUge1xuXHRcdFx0YmFja2dyb3VuZC1jb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5jb2xvcnMucHJpbWFyeUNvbG9yfTtcblx0XHRcdGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbG9ycy5wcmltYXJ5VGV4dENvbG9yfTtcblx0XHR9XG4gICAgfVxuYDtcblxuZXhwb3J0IGRlZmF1bHQgVGFnTGlzdDtcbiJdfQ== */'));

exports.default = TagList;